module.exports = __webpack_public_path__ + "img/flood-hazard@2x.edfcd264.png";